export default "__VITE_ASSET__CyIh9U32__"